import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, input, TemplateRef } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { BehaviorSubject } from 'rxjs'

import { DeviceService } from '@ti/core/common/services'
import { FleetHeaderComponent } from '@ti/core/ui-kit/layout/components/fleet-header'
import { OptionsItem } from '@ti/core/ui-kit/layout/contracts'

import { AuditLogsListModel } from '../services/audit-logs-list.model'
import { AuditLogsGridComponent } from './grid/audit-logs-grid.component'

@Component({
  selector: 'app-audit-logs',
  templateUrl: 'audit-logs.component.html',
  styleUrl: 'audit-logs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AuditLogsListModel],
  imports: [AsyncPipe, FleetHeaderComponent, TranslatePipe, AuditLogsGridComponent],
})
export class AuditLogsComponent {
  public readonly headerTextSize = input<number>(24)
  public readonly headerDescriptionTmpl = input<TemplateRef<unknown> | undefined>()

  protected readonly model = inject(AuditLogsListModel)
  protected readonly deviceService = inject(DeviceService)
  protected readonly adaptiveMenuOptions$ = new BehaviorSubject<OptionsItem[]>([])
}
